import type { QueryKeyFactory } from "app/pages/sales-intelligence/types/queries";

const BASE_KEY = "industry";
const TAXONOMY_QUERY_KEY = "taxonomy";
const AFFINITY_QUERY_KEY = "affinity";

/**
 * Deliberately not under `BASE_KEY`: the taxonomy and its affinity config are cached forever because
 * re-indexing them is O(n), and a prefix invalidation of `["industry"]` — which enrolling invites —
 * would evict them.
 */
const TRANSITION_BASE_KEY = "industry-transition";
const IMPACT_REPORT_QUERY_KEY = "impact-report";
const CRM_JOBS_TRANSITION_QUERY_KEY = "crm-jobs";

export const industryQueryKeys = {
    taxonomy: () => [BASE_KEY, TAXONOMY_QUERY_KEY] as const,
    affinity: () => [BASE_KEY, AFFINITY_QUERY_KEY] as const,
    impactReport: () => [TRANSITION_BASE_KEY, IMPACT_REPORT_QUERY_KEY] as const,
    crmJobsTransition: () => [TRANSITION_BASE_KEY, CRM_JOBS_TRANSITION_QUERY_KEY] as const,
} as const satisfies QueryKeyFactory;
